import React from 'react';

import styles from '../HomeWrapper.module.scss';
import { User } from '../../shared/icons';
import { Icon } from '../../shared/icon/Icon';

interface LogoutButtonProps {
    logout: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ logout }) => (
    <div className={styles.logoutButtonWrapper}>
        <button className={styles.logoutButton} onClick={logout}>
            <Icon icon={User} />
            <div className={styles.logoutButtonLabel}>Logout</div>
        </button>
    </div>
);
